import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-user-avatar',
    template: `
        <div class="btn-icon" id="nav-user-avatar">
            <i class="fa-solid fa-user"></i>
        </div>
    `,
    styles: [
        `
            #nav-user-avatar {
                width: 35px;
                height: 35px;
                border: 1px solid var(--grey-border-color);
                background: white;

                i {
                    color: #0083c3;
                    font-size: 20px;
                }
            }

            .btn-icon {
                background: var(--toolbar-icon-bg);
                border: 0.5px solid var(--sidebar-icon-border);
                box-shadow: 0 2px 2px rgb(0 0 0 / 10%);
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 5px;
                flex-shrink: 0;
                color: var(--toolbar-text-secondary);

                i {
                    font-size: 1.25rem;
                }
            }
        `,
    ],
    standalone: true,
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent {}
